// extracted by mini-css-extract-plugin
export default {"innerWrapper":"wB-z","tooltipWrapper":"xB-z","icon":"yB-z","tooltip":"zB-z","content":"AB-z"};